import React from "react";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink } from "../components/ButtonLink";
import { Breadcrumbs, EmptyState, PageHero, SectionHeading } from "../components/RedlandComponents";
import { ImageGallery } from "../components/ImageGallery";

export default function JuniorGolf() {
  const { juniorGolf } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="Junior Golf" />
      <PageHero
        eyebrow="Growing the Game"
        title={juniorGolf.title}
        copy="A friendly place for young golfers and families to connect with the game."
        image={juniorGolf.heroImage}
        badge="Junior Golf at Redland"
        tags={["Instruction", "Sportsmanship", "Confidence", "Fun"]}
        metaTitle="Families"
        metaItems={["Check back for upcoming events", "Junior Camp details available", "Ages 5-16 camp program"]}
        actions={
          <ButtonLink href="/junior-camp" variant="secondary">
            View Junior Camp
          </ButtonLink>
        }
      />
      <section className="section">
        <div className="container">
          <EmptyState message={juniorGolf.status} />
        </div>
      </section>
      <section className="section section-cream">
        <div className="container">
          <SectionHeading title="Junior Golf Gallery" />
          <ImageGallery items={juniorGolf.gallery} title="Junior Golf image gallery" />
        </div>
      </section>
      <section className="section">
        <div className="container narrow center">
          <h2>Looking for the Current Camp Program?</h2>
          <p>Visit the Junior Camp page for the supplied camp dates, details, costs, and contacts.</p>
          <ButtonLink href="/junior-camp">View Junior Camp</ButtonLink>
        </div>
      </section>
    </>
  );
}
